import {FrontendUserRead} from "@bounce/shared/consumer/declarations";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {useAuth} from "~/auth/useAuth";
import {useConsumerUser} from "~/contexts/user/ConsumerUserContext";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = Record<string, never>;

type Data = FrontendUserRead;

export const getUser = async (): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(`/user`);
  return result.data;
};

export const useGetUserQuery = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  const {loggedIn, userId} = useAuth();
  const {isNoLogin} = useConsumerUser();
  const hasUserAccess = loggedIn || isNoLogin;
  const isEnabledForUser = !!(hasUserAccess && userId);
  return useBaseQuery<Data, Variables>(
    ["user", userId, "accounts"],
    getUser,
    variables,
    {...options, enabled: isEnabledForUser, refetchOnWindowFocus: true}
  );
};
